import { baremesAdapter } from 'src/slices/bareme';
import { constantsAdapter } from 'src/slices/constant';
import { extractionAdapter } from 'src/slices/extraction';
import { invitationsAdapter } from 'src/slices/invitation';
import { organizationsAdapter } from 'src/slices/organization';
import { organizationInvitationsAdapter } from 'src/slices/organizationInvitation';
import { dommageAdapter } from '../slices/dommage';
import { monetaryErosionAdapter } from '../slices/monetaryErosion';
import { prejudiceAdapter } from '../slices/prejudice';
import { procedureAdapter } from '../slices/procedure';
import { victimeAdapter } from '../slices/victime';
import { victimeIndirecteAdapter } from '../slices/victimeIndirecte';
import { RootState } from './index';

export const dommageSelectors = dommageAdapter.getSelectors<RootState>(
  (state) => state.dommage,
);

export const victimeSelectors = victimeAdapter.getSelectors<RootState>(
  (state) => state.victime,
);

export const procedureSelectors = procedureAdapter.getSelectors<RootState>(
  (state) => state.procedure,
);

export const prejudiceSelectors = prejudiceAdapter.getSelectors<RootState>(
  (state) => state.prejudice,
);

export const monetaryErosionSelectors =
  monetaryErosionAdapter.getSelectors<RootState>(
    (state) => state.monetaryErosion,
  );

export const baremeSelectors = baremesAdapter.getSelectors<RootState>(
  (state) => state.bareme,
);

export const victimeIndirecteSelectors =
  victimeIndirecteAdapter.getSelectors<RootState>(
    (state) => state.victimeIndirecte,
  );

export const invitationSelectors = invitationsAdapter.getSelectors<RootState>(
  (state) => state.invitation,
);

export const appConstantsSelector = constantsAdapter.getSelectors<RootState>(
  (state) => state.constant,
);

export const subscriptionSelector = (state: RootState) => state.subscription;

export const organizationSelector =
  organizationsAdapter.getSelectors<RootState>((state) => state.organization);

export const organizationInvitationSelector =
  organizationInvitationsAdapter.getSelectors<RootState>(
    (state) => state.organizationInvitation,
  );

export const extractionSelectors = extractionAdapter.getSelectors<RootState>(
  (state) => state.extraction,
);
